<app-navbar-control></app-navbar-control>

@if (!isLoaded) {
<div class="progress">
  <div class="progress-bar indeterminate"></div>
</div>
}

<section class="pricing-section">

  <div class="container">

    <div class="pricing-header text-center">

      <span class="section-badge">
        PRICING
      </span>

      <h1 class="pricing-title">
        Simple pricing for every stage of growth
      </h1>

      <p class="pricing-subtitle">
        Whether you're an individual professional or a growing organization,
        ClockFlex provides the tools you need to streamline scheduling,
        automate operations, and deliver exceptional customer experiences.
      </p>

    </div>

    <div class="row g-4">

      @for (subscription of subscriptionTypes; track subscription) {

      <div class="col-xl-3 col-lg-4 col-md-6">

        <div class="pricing-card h-100">

          <div class="pricing-card-header">

            <h3 class="plan-name">
              {{ subscription.name }}
            </h3>

            <div class="price-wrapper">

              <span class="price">
                {{ getAmount(subscription) | currency:'INR':'symbol' }}
              </span>

            </div>

            <span class="all-inclusive">
              {{'ALL_INCLUSIVE' | translate}}
            </span>

            @if (subscription.discountInPercentage > 0) {

            <div class="discount-badge">

              <span class="old-price">
                {{ subscription.amount }}
              </span>

              <span>
                {{ subscription.discountInPercentage }}% {{'OFF' | translate}}
              </span>

            </div>

            }

          </div>

          <div class="pricing-features">

            <div class="feature-row">
              <i class="fas fa-calendar-check"></i>
              <span>{{'Bookable_Calendars' | translate}}</span>
              <strong>
                {{ getBookableCalendars(subscription) >= 1000 ? ('Unlimited' | translate) :
                getBookableCalendars(subscription) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-clipboard-check"></i>
              <span>{{'Appointment_Types' | translate}}</span>
              <strong>
                {{ getBookableAppointmentTypes(subscription) >= 1000 ? ('Unlimited' | translate) :
                getBookableAppointmentTypes(subscription) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-users"></i>
              <span>{{'Contributors' | translate}}</span>
              <strong>
                {{ getBookableContributors(subscription) >= 1000 ? ('Unlimited' | translate) :
                getBookableContributors(subscription) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-file-alt"></i>
              <span>{{'Intake_Forms_Allowed' | translate}}</span>
              <strong>
                {{ allowIntakeForms(subscription) === 0 ? ('No' | translate) : ('Yes' | translate) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-credit-card"></i>
              <span>{{'Payment_Integration' | translate}}</span>
              <strong>{{'Yes' | translate}}</strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-envelope"></i>
              <span>{{'Email_Notifications' | translate}}</span>
              <strong>
                {{ allowEmailNotification(subscription) === 0 ? ('No' | translate) : ('Yes' | translate) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-bell"></i>
              <span>{{'Email_Reminders' | translate}}</span>
              <strong>
                {{ allowEmailReminders(subscription) === 0 ? ('No' | translate) : ('Yes' | translate) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-comment-dots"></i>
              <span>{{'SMS_Notifications' | translate}}</span>
              <strong>
                {{ allowSMSNotification(subscription) === 0 ? ('No' | translate) : ('Yes' | translate) }}
              </strong>
            </div>

            <div class="feature-row">
              <i class="fas fa-mobile-alt"></i>
              <span>{{'SMS_Reminders' | translate}}</span>
              <strong>
                {{ allowSMSReminders(subscription) === 0 ? ('No' | translate) : ('Yes' | translate) }}
              </strong>
            </div>

          </div>

          <a [routerLink]="['../auth/create-account']" class="btn pricing-btn">

            {{'Sign_Up' | translate}}

          </a>

        </div>

      </div>

      }

    </div>

  </div>

</section>